export var CommentEditorSource;
(function(CommentEditorSource) {
    CommentEditorSource[/** The user intends to post a comment at the root level of an item. */ "Independent"] = 'independent';
    CommentEditorSource[/** The user intends to reply to a comment that already exists. */ "Reply"] = 'reply';
    CommentEditorSource[/** The user is editing an existing comment. */ "Edit"] = 'edit';
})(CommentEditorSource || (CommentEditorSource = {}));
export var RequestError;
(function(RequestError) {
    RequestError[RequestError["GeneralError"] = 0] = "GeneralError";
})(RequestError || (RequestError = {}));
